import axios from 'axios'
import { getSessionToken } from './session'
import { logClientError } from './errorLogger'

const BACKEND_URL = (import.meta as unknown as { env: Record<string, string> }).env
  .VITE_BACKEND_URL || ''

export const apiClient = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
})

apiClient.interceptors.request.use((config) => {
  const token = getSessionToken()
  if (token) {
    config.headers = config.headers ?? {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    logClientError({
      component: 'apiClient',
      errorType: `http_${error?.response?.status ?? 'network'}`,
      endpoint: error?.config?.url,
    })
    return Promise.reject(error)
  }
)
